// @ts-nocheck
import React from 'react'
import Modal from '@material-ui/core/Modal'
import { inject, observer } from "mobx-react"
import styled from 'styled-components'

import { useStores } from 'hooks/useStores'
import StoresDialogBoxContent from './StoresDialogBoxContent'

import { localeToDir } from 'utils/utils'

const ModalContainer = styled.div`
	outline: none;
	background-color: white;
	position: absolute;
	transform: translate(-50%, -50%);
	left: 50%;
	top: 50%;
	max-width: 1100px;
	margin-top: ${(props) => (props.isMobileApp ? '60px' : '0')};

	@media (max-width: 1024px) {
		height: 100vh;
		width: 100%;
		padding-bottom: 23px;
		position: unset;
		transform: unset;
		left: unset;
		right: unset;
	}
`

const StoresDialogBox = ({Application, Home}) => {
	const { addressManagerV2Store } = useStores()
	const _isMobileApp = Application.isMobileApp
	const { locale = {} } = Home

	return (
		<Modal open={addressManagerV2Store.loading || addressManagerV2Store.addressPopup?.open || false} disableAutoFocus disableEnforceFocus>
			<ModalContainer isMobileApp={_isMobileApp} dir={localeToDir[locale.msg]} data-testid="map-popup">
				<StoresDialogBoxContent />
			</ModalContainer>
		</Modal>
	)
}


export default inject(
	'Home',
	'Application'
)(observer(StoresDialogBox)) as () => React.ReactNode
